"use client";
import Card from "./Card";
import { PreviewServiceBlock } from "@/payload-types";
import RichText from "@onclicks/sharedcomponents/RichText";
import { CMSLink } from "../../CMSLink";

const Cards: React.FC<PreviewServiceBlock> = (data) => {
  const { title, selectedPages, richText, links } = data;

  return (
    <section id="products" className="lg:p-16 mt-5 lg:-mt-36">
      <div className="flex flex-col lg:flex-row items-center lg:gap-x-25">
        <div className="mx-auto max-w-2xl lg:shrink-0 text-center lg:text-left">
          {title && (
            <h1 className="text-[#FB7303] text-3xl font-bold">{title}</h1>
          )}
          {richText && (
            <RichText
              data={richText}
              enableGutter={false}
              className="mb-4 text-2xl font-bold"
            />
          )}
          {links &&
            links.map((link, index) => <CMSLink key={index} {...link.link} />)}
        </div>

        <div className="mx-auto my-8 flex items-center justify-center gap-x-6">
          {selectedPages &&
            selectedPages.map((card, index) => (
              <Card key={index} card={card} />
            ))}
        </div>
      </div>
    </section>
  );
};

export default Cards;
